/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；视觉基准 docs/旅游落地页/cj商旅-01.html。
 * 注意事项：
 * 1. 复刻原型 .cjbt-premium-pay / .cjbt-compact-cta 两处内联 <script> 的滚动进场逻辑：
 *    IntersectionObserver 命中即加 is-visible 并 unobserve；prefers-reduced-motion 或无 IO 时直接置可见
 *    （与原型 else 分支一致，保证降级后内容不会停留在初始隐藏态）。
 * 2. 同构安全：SSR 阶段只返回 ref，不访问 window。
 * 3. 与 app/web/page/entity/components/useScrollReveal.js 同源思路，但本页 threshold 按原型逐区块给
 *    （payment 0.15 / cta 0.16），且原型无 readyClass（初态写在 CSS 里），故本 hook 只管 visibleClass。
 *
 * @param {string} visibleClass 命中视口后追加的类名（原型统一为 is-visible）
 * @param {number} threshold IntersectionObserver 阈值
 * @returns {Object} 挂到区块根节点的 ref
 */
import { useRef, useEffect } from 'react';

export default function useScrollReveal(visibleClass, threshold) {
  var ref = useRef(null);

  useEffect(function () {
    var node = ref.current;
    if (!node || typeof window === 'undefined') return undefined;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      node.classList.add(visibleClass);
      return undefined;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(visibleClass);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: threshold });

    observer.observe(node);
    return function () { observer.disconnect(); };
  }, [visibleClass, threshold]);

  return ref;
}
